/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 15:38:39
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-11 14:17:54
 * @name: 主文件
 * @Description: 主文件
 * @FilePath: \project\src\main.js
 * @Author: desktop
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'; //element组件
import '@/scss/element-variables.scss'; //element样式
import '@/assets/scss/reset.scss'; //全局默认样式
import scssVars from '@/scss/var.scss'; //scss变量
import '@/entrance'; //入口文件
import commenMixin from "@/mixins/common.js"; //公共混入

Vue.mixin(commenMixin);
Vue.use(ElementUI);

Vue.config.productionTip = false

Vue.prototype.$scssVars = scssVars;
Vue.prototype.$EventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
